<!-- eslint-disable vue/no-v-html -->
<template>
  <span
    class="search-result-icon"
    data-test="search-result-icon"
    v-html="iconCharacter"
  />
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { GLYPH_FONTS } from '@/lib/glyph-markers-constants'
import { getGlyphIconFromSearchResultType } from '@/lib/glyph-markers'

const { resultType } = defineProps<{
  resultType?: string
}>()

const iconFontFamily = ref(GLYPH_FONTS.ICON)

const iconCharacter = computed(() => {
  return getGlyphIconFromSearchResultType(resultType)
})
</script>

<style scoped>
.search-result-icon {
  font-family: v-bind(iconFontFamily);
  font-size: var(--ys-text-title3-fontSize);
  text-align: center;
}
</style>
